import { IOption } from '../../config/interfaces/IOption';
import { query } from '../apiInstance';

export const getDictionaries = query<null, IOption<string>[]>();
